<template>
  <div>
    <select-base
      ref="base"
      v-model="valueInner"
      :multiple="multiple"
      :require="false"
      :label="'Etiqueta'"
      :label-select="'descricao'"
      :carregar="carregarEtiqueta"
      :filtro-adicional="filtroAdicional"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import api from '@/app-modulo/comercial/cadastro-proposta/shared/components/cadastro-etiqueta/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'EtiquetaSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      value_: null,
      filtros: [
        {
          colunas: ['Descricao'],
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        this.value_ = value
      },
      get() {
        return this.value_
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarEtiqueta() {
      return api.getEtiquetas(this.filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
